<template lang="pug">
  .Papers
    .background
    .content
      h1(:class="titleAnimation") ALPHA 团队于 KDD、AAAI、SIGIR等国际顶级会议上累计发布七篇专业论文
      div(:class="contentAnimation")
        .text(v-for="(item, index) in papers" :class="[contentAnimation, `animateDelay-${index}`]") {{ item }}
      //.offer Offer your Project to Alpha team
      //.button(@click="gotoOfficial") 浏览官网→
</template>

<script>
  import Mixin from '../index.js'
  import {isPhone} from "@/utils/utils";

  export default {
    name: "Papers",
    mixins: [Mixin],
    data() {
      return {
        papers: [
          '1. Collecting Indicators of Compromise from Unstructured Text of Cybersecurity Articles using Neural-Based Sequence Labelling',
          '2. Automatic Identification of Indicators of Compromise using Neural-Based Sequence Labelling',
          '3. Attention based Term Weighting for App Retrieval',
          '4. A topic enhanced approach to detecting multiple standpoints in web texts',
          '5. Multi-Target Stance Detection via a Dynamic Memory-Augmented Network',
          '6. FDML: A Collaborative Machine Learning Framework for Distributed Features',
          '7. Condensed Convolution Neural Network by Attention over Self-attention for Stance Detection in Twitter',
        ],
        Alpha: 'http://www.alphaif.com/',
        contentAnimate: 'animated fadeInRight'
      };
    },
    methods: {
      gotoOfficial() {
        const alphaOfficialLink = this.Alpha;
        if (isPhone()) {
          this.$alert(`建议您通过PC端浏览器打开官网, \n网址：${alphaOfficialLink}`, "通知", {
            confirmButtonText: '继续',
            cancelButtonText: '取消',
            showCancelButton: true,
            center: true,
            callback(action) {
              if (action === 'confirm') {
                window.open(alphaOfficialLink, '_blank');
              }
            }
          })
        } else {
          window.open(alphaOfficialLink, '_blank');
        }
      },
    }
  };
</script>

<style scoped lang="stylus">
  @import "../index.styl"
  .Papers {
    VStack(center)
    padding 100px 0
    position relative
    .background {
      position absolute
      top 0
      left 0
      width 100%
      height 100%
      mask url("../../../assets/images/background2.png") no-repeat center
      background-color #ededed
    }
    .content {
      VStack()
      z-index 1
    }
    h1 {
      font-size 24px
      FontSetting("思源黑体")
      font-weight 600
      letter-spacing 1px
      color #222
      position relative
      margin-bottom 8px
      &::before {
        content '"'
        position absolute
        left -70px
        top -20px
        font-size 106px
        FontSetting(Lora)
        font-weight 400
        color #eae9e9
      }
      &::after {
        content none
      }
    }
    .text {
      font-size 14px
      line-height 26px
      FontSetting("思源黑体")
      font-weight 300
      color #999
    }
    .offer {
      font-size 30px
      FontSetting(Montserrat)
      font-weight 200
      color #555555
      align-self center
      margin 43px 0
    }
    .button {
      box-sizing border-box
      cursor pointer
      align-self center
      width 168px
      height 48px
      border-radius 24px
      color white
      background-color #269bff
      HStack(center, center)
      font-size 16px
      FontSetting("Source Han Sans CN Regular")
    }
    @media (max-width screenWidth) {
      padding 50px 0
      .content {
        h1 {
          padding 20px
        }
        > div {
          padding 20px
          font-size 16px
          margin 0
        }
      }
      .button {
        font-size 14px
        height 34px
        width 35%
      }
    }
  }
</style>
